import { jsx as l } from "react/jsx-runtime";
import { tv as m } from "tailwind-variants";
const r = m({
  base: ["italic", "text-sm", "text-neutral-500"]
}), o = ({ children: t, className: e, id: s, tagName: a = "p" }) => /* @__PURE__ */ l(a, { className: r({ class: e }), id: s, children: t });
o.displayName = "HelperText";
export {
  o as default
};
